import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'
import type User from 'modules/core/store/models/User'

import type PermissionGroup from 'modules/permissions/store/models/PermissionGroup'

import Form from './Form'
// Hooks
import useForm from './useForm'
import useSubmit from './useSubmit'

interface Props {
  onClose: () => void
  permissionGroup: PermissionGroup
  user?: User
}

const EditUserModal = ({ onClose, permissionGroup, user }: Props) => {
  const form = useForm({
    user,
    permissionGroup,
  })

  const { submitting, onSubmit } = useSubmit({
    form,
    user,
  })

  const title = user
    ? i18n.t('settings.users.edit_modal.title')
    : i18n.t('settings.users.add_modal.title')

  const description = user
    ? i18n.t('settings.users.edit_modal.description')
    : i18n.t('settings.users.add_modal.description')

  const email = form.get('email').value

  const isDisabled =
    !email ||
    !!users.find({
      email,
    })

  return (
    <Modal
      title={title}
      description={description}
      illustration="add-user"
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        <Button disabled={(isDisabled || submitting) && !form.isDirty} submit>
          {i18n.t('common.save')}
        </Button>
      }
    >
      <Form form={form} />
    </Modal>
  )
}

export default observer(EditUserModal)
